// Convert GitHub alert blockquotes ([!NOTE], [!TIP], etc.) after `marked`
// renders them, since alert syntax is not part of CommonMark/GFM.
const ALERT_META = {
  NOTE: { label: "Note", icon: "ℹ️", className: "note" },
  TIP: { label: "Tip", icon: "💡", className: "tip" },
  IMPORTANT: { label: "Important", icon: "❗", className: "important" },
  WARNING: { label: "Warning", icon: "⚠️", className: "warning" },
  CAUTION: { label: "Caution", icon: "🛑", className: "caution" },
};

// Matches the blockquote shape emitted by marked for GitHub alerts.
const ALERT_RE =
  /<blockquote>\s*<p>\s*\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]\s*([\s\S]*?)<\/blockquote>/gi;

export function transformGithubAlerts(html) {
  return String(html || "").replace(ALERT_RE, (match, type, rawBody) => {
    const meta = ALERT_META[type.toUpperCase()];
    if (!meta) return match;

    // Restore the paragraph boundary that the regex consumes with the marker.
    const startsWithStrayClose = rawBody.startsWith("</p>");
    const body = startsWithStrayClose ? rawBody.slice(4) : rawBody;
    const opening = startsWithStrayClose ? "" : "<p>";

    return (
      `<div class="markdown-alert markdown-alert-${meta.className}">` +
      `<p class="markdown-alert-title">${meta.icon} ${meta.label}</p>` +
      `${opening}${body}` +
      `</div>`
    );
  });
}
